module.exports = __webpack_public_path__ + "img/levels-50_small.cee06ba7.png";